// AIDEV-NOTE: Module-level cache for eligible survey triggers
// Accessible from non-React code (analytics.ts) to check if an event should trigger a survey
// Updated by SurveyProvider when React Query data changes

let cachedTriggers: Set<string> | null = null;

/**
 * Get the cached set of eligible trigger event names
 * Returns null if cache is not yet populated
 */
export function getCachedEligibleTriggers(): Set<string> | null {
    return cachedTriggers;
}

/**
 * Update the cache with a new list of trigger event names
 * Called by SurveyProvider when eligible triggers data changes
 */
export function setCachedEligibleTriggers(triggers: string[]): void {
    cachedTriggers = new Set(triggers);
}

/**
 * Clear the cache (e.g., on logout)
 */
export function clearEligibleTriggersCache(): void {
    cachedTriggers = null;
}
